<template>
	<div :style="shu.yangshi" class="zidingyi_gonggao">
		<div class="zidingyi_gonggao_lefttu" :style="yangshitu">
			<el-image src="http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/Y4Wz8021C2x05Z554282023xx36v8x.png" ></el-image>
		</div>
		<div class="zidingyi_gonggao_zuo">
			<el-carousel height="20px" direction="vertical" :autoplay="true" :interval="1000">
				<el-carousel-item v-for="l in shu.shu">
					<div class="medium" :style="yangshi">{{l.ming}}</div>
				</el-carousel-item>
			</el-carousel>
		</div> 
	</div>
</template>

<script>
	export default {
		name: 'gongao',
		data() {
			return {
				gundong: [{
					ming: '公告一'
				}, {
					ming: '公告一'
				}, {
					ming: '公告一'
				}],
				yangshitu:'',
				yangshi:''
			}
		},
		props: {
			shu: {
				type: Object,
				default () {
					return {
						wenzi: '输入文字',
						yangshi: {}
					}
				}
			}
		},
		created() {
			if (!this.shu.shu) {
				this.$set(this.shu, 'shu', this.gundong)
			}
			if (!this.shu.yangshitu) {
				this.$set(this.shu, 'yangshitu', {})
			}	
			if (!this.shu.yangshi) {
				this.$set(this.shu, 'yangshi', {})
			}	
		},
		watch: {		
			'shu.yangshitu.width':function(){
				this.Ys();
			},
			'shu.yangshitu.height':function(){
				this.Ys();
			},
			'shu.yangshitu.text_align':function(){
				this.Ys();
			},
			'shu.yangshitu.margin':function(){
				this.Ys();
			},
			'shu.yangshitu.padding':function(){
				this.Ys();
			},
			// 滚动
			'shu.yangshi.width':function(){
				this.Ysz();
			},
			'shu.yangshi.height':function(){
				this.Ysz();
			},
			'shu.yangshi.text_align':function(){
				this.Ysz();
			},
			'shu.yangshi.margin':function(){
				this.Ysz();
			},
			'shu.yangshi.padding':function(){
				this.Ysz();
			},
			'shu.yangshi.color':function(){
				this.Ysz();
			},
		},
		methods:{
			Ys(){
				this.yangshitu = "";
				var px='';
				if (this.shu.yangshitu.width) {
					px=(this.shu.yangshitu.width>0)?(this.shu.yangshitu.width+'px'):this.shu.yangshitu.width;					
					this.yangshitu += "width:" +px+ ";";
				}
				if (this.shu.yangshitu.height) {				
					px=(this.shu.yangshitu.height>0)?(this.shu.yangshitu.height+'px'):this.shu.yangshitu.height;		
					this.yangshitu += "height:" + px+ ";";
				}
				if (this.shu.yangshitu.text_align) {				
					this.yangshitu += "text-align:" + this.shu.yangshitu.text_align+ ";";
				}	
				if (this.shu.yangshitu.margin) {
					px=(this.shu.yangshitu.margin>0)?(this.shu.yangshitu.margin+'px'):this.shu.yangshitu.margin;		
					this.yangshitu += "margin:" + px+ ";";
				}
				if (this.shu.yangshitu.padding) {
					px=(this.shu.yangshitu.padding>0)?(this.shu.yangshitu.padding+'px'):this.shu.yangshitu.padding;		
					this.yangshitu += "padding:" + px+ ";";
				}
				if (this.shu.yangshitu.border_radius) {
					px=(this.shu.yangshitu.border_radius>0)?(this.shu.yangshitu.border_radius+'px'):this.shu.yangshitu.border_radius;		
					this.yangshitu += "border-radius:" + px+ ";";
				}
				console.log(this.yangshitu)
			},
			Ysz(){
				this.yangshi = "";
				var px='';
				if (this.shu.yangshi.width) {
					px=(this.shu.yangshi.width>0)?(this.shu.yangshi.width+'px'):this.shu.yangshi.width;					
					this.yangshi += "width:" +px+ ";";
				}
				if (this.shu.yangshi.height) {				
					px=(this.shu.yangshi.height>0)?(this.shu.yangshi.height+'px'):this.shu.yangshi.height;		
					this.yangshi += "height:" + px+ ";";
				}
				if (this.shu.yangshi.text_align) {				
					this.yangshi += "text-align:" + this.shu.yangshi.text_align+ ";";
				}	
				if (this.shu.yangshi.margin) {
					px=(this.shu.yangshi.margin>0)?(this.shu.yangshi.margin+'px'):this.shu.yangshi.margin;		
					this.yangshi += "margin:" + px+ ";";
				}
				if (this.shu.yangshi.padding) {
					px=(this.shu.yangshi.padding>0)?(this.shu.yangshi.padding+'px'):this.shu.yangshi.padding;		
					this.yangshi += "padding:" + px+ ";";
				}
				if (this.shu.yangshi.color) {
					this.yangshi += "color:" + this.shu.yangshi.color+ ";";
				}
				console.log(this.yangshi)
			}
		}

	}
</script>
